import React, { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { logout } from '../../store/thunks/authThunks';
import swal from 'sweetalert';
import { getNotificationList } from '../../store/thunks/notificationThunk';
import { addNotification, deleteNotification, updateNotification } from '../../services/notification';
import { TrashIcon } from '@heroicons/react/outline';
import { setData } from '../../store/slices/notificationSlice';

const Notification = () => {
    const [showModal, setShowModal] = useState(false);
    const [showWarn, setShowWarn] = useState(false);
    const authToken = useSelector((state) => state.auth.token);
    const [notification, setNotification] = useState('');
    const [tag, setTag] = useState('');
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { isAuthenticated } = useSelector((state) => state.auth);
    const { list, total, loading, error } = useSelector((state) => state.notification);
    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [sortField, setSortField] = useState(null);
    const [sortOrder, setSortOrder] = useState(null);
    const token = useSelector((state) => state.auth.token);

    useEffect(() => {
        if (!isAuthenticated && error?.message === 'unauthorized') {
          navigate('/login');
        }
      }, [isAuthenticated, error, navigate]);

    useEffect(() => {
          if(error && error.toLowerCase()==='invalid token'){
            handleLogout();
          }    
        }, [error]);

    useEffect(() => {
        if (token) {
          dispatch(getNotificationList({ page, limit: rowsPerPage, sortField, sortOrder }));
        }    
      }, [dispatch, page, rowsPerPage, sortField, sortOrder, token]);

    const handleLogout = () => {
          dispatch(logout());
          navigate('/login');
        };

    const columns = [
      { name: 'Tag', selector: (row) => row.tag, sortable: true },
      { name: 'Notification', selector: (row) => row.notification, sortable: true },
      { name: 'Top Notification', selector: (row) => row.topNotification, sortable: false, cell: (row) => (
        <label className="inline-flex items-center cursor-pointer relative">
          <input
            type="checkbox"
            className="sr-only peer"
            checked={row.topPosition}
            onChange={() => handleToggle(row, 't')}
          />
          <div className="w-11 h-6 bg-gray-200 rounded-full peer-checked:bg-green-500 transition-colors"></div>
          <div className="absolute left-0.5 top-0.5 w-5 h-5 bg-white rounded-full transition-transform duration-300 peer-checked:translate-x-5"></div>
        </label>
      ) },
      { name: 'Bottom Notification', selector: (row) => row.bottomNotification, sortable: false, cell: (row) => (
        <label className="inline-flex items-center cursor-pointer relative ">
          <input
            type="checkbox"
            className="sr-only peer"
            checked={row.bottomPosition}
            onChange={() => handleToggle(row, 'b')}
          />
          <div className="w-11 h-6 bg-gray-200 rounded-full peer-checked:bg-green-500 transition-colors"></div>
          <div className="absolute left-0.5 top-0.5 w-5 h-5 bg-white rounded-full transition-transform duration-300 peer-checked:translate-x-5"></div>
        </label>
      ) },
      {
        name: 'Delete',
        selector: (row) => '',
        sortable: false,
        cell: (row) => (
          <button
            onClick={() => showDeleteWarn(row._id)}
            className="text-red-500 hover:text-red-700 cursor-pointer"
            title="Delete"
          >
            <TrashIcon className="h-5 w-5" />
          </button>
        ),
      }
  ];

  const handleToggle = async (row, position) => {
    let data = {}
    if(position==='t'){
      data = {
        topPosition: !row.topPosition
      }
    }else{
      data = {
        bottomPosition: !row.bottomPosition
      }
    }
      await updateNotification(row._id, data, token.token)
          .then(response=>{
            if(response?.data?.success){
              dispatch(getNotificationList({ page, limit: rowsPerPage, sortField, sortOrder }));
          
              swal({
                title: "Notification",
                text: response?.data?.message,
                icon: "success",
                buttons: true,
              });
            }
          })
          .catch(error=>{
            swal({
                  title: "Notification",
                  text: error?.response?.data?.error,
                  icon: "error",
                  buttons: true,
                });
          });
    };

    const handleAddNotification = () => {
      setShowModal(true);
      setShowWarn(false);
    };

    const closeModal = () => {
      setShowModal(false);
      setShowWarn(false);
    };

    const saveNotification = async () => {
        try {
          if(!notification){
            setShowWarn(true);
            return;
          }
          if(!tag){
            setShowWarn(true);
            return;
          }

          let data = {
            tag, notification
          }
          const resp = await addNotification(data, authToken.token);
            
          if(resp?.data?.success){
            closeModal();
            swal({
                title: "Notification",
                text: resp?.data?.message,
                icon: "success",
                buttons: true,
              });
              dispatch(getNotificationList({ page, limit: rowsPerPage, sortField, sortOrder }));
          }
        } catch (error) {
          swal({
                  title: "Notification",
                  text: error?.response?.data?.error,
                  icon: "error",
                  buttons: true,
                });
        }    
      }
    
      const handleChange = (e) => {
        setNotification(e.target.value);
        setShowWarn(false);
      }

      const setTagVal = (e) => {
        setTag(e.target.value);
        setShowWarn(false);
      }

      const showDeleteWarn = (id)=>{
        swal({
                title: "Delete",
                text: 'Do you really want to delete',
                icon: "warning",
                buttons: true,
                 dangerMode: true,
              }).then((willDelete) => {
                if (willDelete) {
                  // ✅ Call your delete function here
                  handleDelete(id);
                }
              });
      }

      const handleDelete = async (id) => {
        await deleteNotification(id, authToken.token)
        .then(response=>{
            swal({
              title: "Delete",
              text: response?.data?.message,
              icon: "success",
              buttons: true,
            });
            dispatch(getNotificationList({ page, limit: rowsPerPage, sortField, sortOrder }));
        })
        .catch(error=>{
          swal({
              title: "Delete",
              text: error?.response?.data?.error,
              icon: "error",
              buttons: true,
            });
        });
      }

  return (
    <div className="p-4">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-2xl font-bold">Notifications</h2>
          <button
            onClick={handleAddNotification}
            className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition cursor-pointer"
          >
            + Add Notification
          </button>
        </div>
        <DataTable
          columns={columns}
          data={list}
          progressPending={loading}
          pagination
          paginationServer
          paginationPerPage={rowsPerPage}
          paginationTotalRows={total}
          onChangePage={(page) => setPage(page)}
          onChangeRowsPerPage={(newPerPage, page) => {
            setRowsPerPage(newPerPage);
            setPage(page);
          }}
          onSort={(column, sortDirection) => {
            setSortField(column.sortField);     // or column.name if API expects field name
            setSortOrder(sortDirection);
          }}
          highlightOnHover
          pointerOnHover
          striped
        />

        {/* Modal */}
      {showModal && (
        <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
          <div className="bg-white rounded-lg p-6 w-full max-w-md shadow-lg">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-xl font-bold">Add Event</h2>
              <button
                className="text-gray-600 hover:text-gray-800 cursor-pointer"
                onClick={closeModal}
              >
                ✕
              </button>
            </div>

            {showWarn && !tag && <div className="text-red-500">*Please add tag.</div>}
              <div className="mb-4">
                <label className="block text-sm font-medium mb-1">Tag*</label>
                <input
                  type="text"
                  className="w-full border border-gray-300 px-3 py-2 rounded"
                  placeholder="Enter tag"
                  name="notification_tag"
                  value={tag}
                  onChange={setTagVal}
                />
              </div>

            {showWarn && !notification && <div className="text-red-500">*Please add notification.</div>}
              <div className="mb-4">
                <label className="block text-sm font-medium mb-1">Notification*</label>
                <input
                  type="text"
                  className="w-full border border-gray-300 px-3 py-2 rounded"
                  placeholder="Enter notification"
                  name="notification"
                  value={notification}
                  onChange={handleChange}
                />
              </div>
              {/* Add more form fields here if needed */}

              <div className="text-right">
                <button
                  type="button"
                  onClick={closeModal}
                  className="bg-gray-100 text-gray-800 px-4 py-2 rounded mr-2 cursor-pointer"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 cursor-pointer"
                  onClick={saveNotification}
                >
                  Save
                </button>
              </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default Notification
